<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { EmailSenderFormSubmitEventPayload, EmailSenderViewModel } from "@Evaluation/Estimations/Components/EmailSender";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class EmailSender extends Vue
    {
        get vm(): EmailSenderViewModel { return this.$props.viewModel as EmailSenderViewModel; }
        get opened() : boolean { return this.vm?.opened ?? false; }

        get sending() : boolean { return this.vm.sending; }
        get recipientIds(): number[] { return this.vm.recipientIds; }

        get emailSubject(): string { return this.vm.emailSubject; }
        set emailSubject(val: string) { this.vm.emailSubject = val; }

        get emailBody(): string { return this.vm.emailBody; }
        set emailBody(val: string) { this.vm.emailBody = val; }
        get emailBodyError(): string { return this.emailBody.indexOf("{url}") === -1 ? "{url} is required in the message. " : null };

        handleFormSubmit()
        {
            this.vm.sending = true;

            const payload = new EmailSenderFormSubmitEventPayload(this.emailSubject, this.emailBody, this.recipientIds)
            this.$emit('form-submit', payload);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask modal-mask-front" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Send email ({{recipientIds.length}})</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form id="email-sender-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Subject:</label>
                                <input type="text" class="form-control" v-model.trim="emailSubject" required />
                            </div>
                            <div class="form-group">
                                <textarea rows="5" class="form-control" v-model.trim="emailBody" required />
                                <div class="error">{{emailBodyError}}</div>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="close"  class="btn btn-outline-secondary">Close</button>
                        <button type="submit" form="email-sender-form" :disabled="sending" class="btn btn-primary">Send email</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>